import { CentralSlice, createCentralStore } from "./central.store";
import { create } from "zustand";

interface CentralStoreTypes extends CentralSlice {}

export const useCentralStore = create<CentralStoreTypes>((...args) => ({
	...createCentralStore(...args),
}));
